import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  emSharedModelService,
} from 'app/services';
import { alerts, actionIcon, ssAutocomplete } from 'app/components/global';
import functions from '../functions';
import editFunctionDialog from '../functions/dialog.editFunctionDialog';
import uniqueProcessNameValidator from '../validators/process-unique-name.validator.directive';
import controller from './edit-process-dialog.controller';
import template from './edit-process-dialog.html';
import messages from '../messages/process.name.messages.html';
import successionPlanning from '../successionPlanning';


class dialogService {
  getOptions($event, {
    customerId = 0,
    department = null,
    process = {
      processId: 0,
      canEditProcess: true,
    },
    isIt = false,
    successorOptions = []
  }) {
    return {
      controller,
      controllerAs: 'editProcessDialogVM',
      locals: {
        customerId,
        department,
        process,
        isIt,
        successorOptions
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.editProcessDialog', [
  ssDialogService,
  alerts,
  actionIcon,
  loaderService,
  emDataService,
  emSharedModelService,
  editFunctionDialog,
  functions,
  ssAutocomplete,
  successionPlanning
])
  .service('editProcessDialog', dialogService)
  .directive('emProcessUniqueName', uniqueProcessNameValidator)
  .run(($templateCache) => {
    $templateCache.put('process.name.messages.html', messages);
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.editProcessDialog created');
